import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "bg-white fixed w-full z-40 top-0 text-md border-b",
  "data-testid": "general-navigation"
}
const _hoisted_2 = { class: "container w-full mx-auto flex items-center" }
const _hoisted_3 = { class: "flex-1 pl-0" }
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 0,
  class: "flex"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "flex"
}
const _hoisted_9 = { class: "hide-until-lg h-10 pl-4" }
const _hoisted_10 = { class: "pl-3 pr-3 py-2 text-white bg-red" }
const _hoisted_11 = {
  class: "flex-1 flex pr-0 mt-auto items-end justify-end",
  "data-testid": "general-navigation-links"
}
const _hoisted_12 = ["data-testid"]
const _hoisted_13 = ["data-testkey"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            "data-testid": "general-navigation-tool-name",
            to: _ctx.RoutePath.ROOT
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("img", {
                  alt: "Oliver Wyman",
                  class: "hide-until-lg h-6",
                  src: "/images/oliver-wyman.png"
                }, null, -1)),
                (_ctx.clientLogo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hide-until-lg w-5 h-10 border-r-2 border-grey" }, null, -1)),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hide-until-lg w-5 h-10" }, null, -1)),
                      _createElementVNode("img", {
                        alt: "Client logo",
                        class: "hide-until-lg h-10",
                        src: `/images/${_ctx.clientLogo}`
                      }, null, 8, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hide-until-lg w-5 h-10 border-r-2 border-grey" }, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hide-until-lg w-5 h-10" }, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  alt: "Pharos",
                  class: "self-center inline-block h-8",
                  src: "/images/pharos.png"
                }, null, -1)),
                (_ctx.isNotProduction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hide-until-lg w-5 h-10 border-r-2 border-grey" }, null, -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t(`general.non-production-environment`)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (navItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: navItem.name,
            class: "mr-4 my-0",
            "data-testid": `top-navigation-${navItem.name}`
          }, [
            (navItem.name === _ctx.RouteName.LOGGED_OUT)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["nav-link", _ctx.isActiveClass(navItem)]),
                  "data-testid": "nav-link",
                  "data-testkey": navItem.name,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestLogout && _ctx.requestLogout(...args)))
                }, _toDisplayString(_ctx.$t(`navigation.${navItem.name}`)), 11, _hoisted_13))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: _normalizeClass(["nav-link", _ctx.isActiveClass(navItem)]),
                  "data-testid": "nav-link",
                  "data-testkey": navItem.name,
                  to: navItem.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`navigation.${navItem.name}`)) + " ", 1),
                    (_ctx.notificationCounts[navItem.meta.notificationCountKey])
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["notification-count", {
                  'notification-count-bg-red':
                    navItem.name === _ctx.RouteName.LEAD_OVERVIEW,
                }])
                        }, _toDisplayString(_ctx.notificationCounts[navItem.meta.notificationCountKey]), 3))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class", "data-testkey", "to"]))
          ], 8, _hoisted_12))
        }), 128))
      ])
    ])
  ]))
}